module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/media/opponent-jorge-masvidal-mobile.b9f5b1ca.mp4";